/**
 * Quick add de las tarjetas de producto.
 *
 * Un solo listener delegado en document en lugar de un componente por tarjeta:
 * una rejilla puede tener decenas y el markup lo pinta un snippet, no un
 * custom element. También sobrevive a que la rejilla se vuelva a renderizar
 * al filtrar, porque el listener no vive en el DOM sustituido.
 *
 * Productos con más de una variante no se agregan a ciegas: se emite el evento
 * cancelable nia:variant-picker:open. El selector de variante lo escuchará y
 * llamará preventDefault(); mientras no exista, se navega a la ficha, que es
 * la caída correcta.
 */
const DONE_MS = 1600;

async function addToCart(button) {
  const variantId = button.dataset.variant;
  if (!variantId) return;

  const card = button.closest('[data-nia-product-card]');
  const status = card?.querySelector('[data-nia-add-status]');
  const label = button.dataset.label || 'Agregar';

  button.setAttribute('busy', '');
  button.disabled = true;

  try {
    const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || `cart/add.js respondió ${response.status}`);
    }

    button.removeAttribute('busy');
    button.textContent = 'Agregado ✓';
    if (status) status.textContent = 'Producto agregado al carrito';

    const drawer = document.getElementById('nia-cart-drawer');
    if (drawer && typeof drawer.openWithRefresh === 'function') {
      drawer.openWithRefresh();
    }

    setTimeout(() => {
      button.textContent = label;
      button.disabled = false;
      if (status) status.textContent = '';
    }, DONE_MS);
  } catch (error) {
    console.warn('[nia-product-card] No se pudo agregar:', error);
    button.removeAttribute('busy');
    button.textContent = label;
    button.disabled = false;
    if (status) status.textContent = 'No se pudo agregar. Inténtalo de nuevo.';
  }
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('[data-nia-add]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  event.preventDefault();

  if (Number(button.dataset.variants) > 1) {
    const ask = new CustomEvent('nia:variant-picker:open', {
      bubbles: true,
      cancelable: true,
      detail: { productUrl: button.dataset.productUrl, trigger: button },
    });

    // Si nadie lo atiende, la ficha del producto es el destino correcto.
    if (button.dispatchEvent(ask) && button.dataset.productUrl) {
      window.location.assign(button.dataset.productUrl);
    }
    return;
  }

  addToCart(button);
});
